function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/image/imageinlineediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { ClipboardPipeline } from 'ckeditor5/src/clipboard';
import { UpcastWriter } from 'ckeditor5/src/engine';
import { modelToViewAttributeConverter, srcsetAttributeConverter } from './converters';
import ImageEditing from './imageediting';
import ImageTypeCommand from './imagetypecommand';
import ImageUtils from '../imageutils';
import { getImageTypeMatcher, createImageViewElement, determineImageTypeForInsertionAtSelection } from '../image/utils';
/**
 * The image inline plugin.
 *
 * It registers:
 *
 * * `<imageInline>` as an inline element in the document schema, and allows `alt`, `src` and `srcset` attributes.
 * * converters for editing and data pipelines.
 * * {@link module:image/image/imagetypecommand~ImageTypeCommand `'imageTypeInline'`} command that converts block images into
 * inline images.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageInlineEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageInlineEditing, _Plugin);

  var _super = _createSuper(ImageInlineEditing);

  function ImageInlineEditing() {
    _classCallCheck(this, ImageInlineEditing);

    return _super.apply(this, arguments);
  }

  _createClass(ImageInlineEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var schema = editor.model.schema; // Converters 'alt' and 'srcset' are added in 'ImageEditing' plugin.

      schema.register('imageInline', {
        isObject: true,
        isInline: true,
        allowWhere: '$text',
        allowAttributes: ['alt', 'src', 'srcset']
      }); // Disallow inline images in captions (for now). This is the best spot to do that because
      // independent packages can introduce captions (ImageCaption, TableCaption, etc.) so better this
      // be future-proof.

      schema.addChildCheck(function (context, childDefinition) {
        if (context.endsWith('caption') && childDefinition.name === 'imageInline') {
          return false;
        }
      });

      this._setupConversion();

      if (editor.plugins.has('ImageBlockEditing')) {
        editor.commands.add('imageTypeInline', new ImageTypeCommand(this.editor, 'imageInline'));

        this._setupClipboardIntegration();
      }
    }
    /**
     * Configures conversion pipelines to support upcasting and downcasting
     * inline images (inline image widgets) and their attributes.
     *
     * @private
     */

  }, {
    key: "_setupConversion",
    value: function _setupConversion() {
      var editor = this.editor;
      var t = editor.t;
      var conversion = editor.conversion;
      var imageUtils = editor.plugins.get('ImageUtils');
      conversion.for('dataDowncast').elementToElement({
        model: 'imageInline',
        view: function view(modelElement, _ref) {
          var writer = _ref.writer;
          return writer.createEmptyElement('img');
        }
      });
      conversion.for('editingDowncast').elementToElement({
        model: 'imageInline',
        view: function view(modelElement, _ref2) {
          var writer = _ref2.writer;
          return imageUtils.toImageWidget(createImageViewElement(writer, 'imageInline'), writer, t('image widget'));
        }
      });
      conversion.for('downcast').add(modelToViewAttributeConverter(imageUtils, 'imageInline', 'src')).add(modelToViewAttributeConverter(imageUtils, 'imageInline', 'alt')).add(srcsetAttributeConverter(imageUtils, 'imageInline')); // More image related upcasts are in 'ImageEditing' plugin.

      conversion.for('upcast').elementToElement({
        view: getImageTypeMatcher(editor, 'imageInline'),
        model: function model(viewImage, _ref3) {
          var writer = _ref3.writer;
          return writer.createElement('imageInline', {
            src: viewImage.getAttribute('src')
          });
        }
      });
    }
    /**
     * Integrates the plugin with the clipboard pipeline.
     *
     * Idea is that the feature should recognize the user's intent when an **block** image is
     * pasted or dropped. If such an image is pasted/dropped into a non-empty block
     * (e.g. a paragraph with some text) it gets converted into an inline image on the fly.
     *
     * We assume this is the user's intent if they decided to put their image there.
     *
     * **Note**: If a block image has a caption, it will not be converted to an inline image
     * to avoid the confusion. Captions are added on purpose and they should never be lost
     * in the clipboard pipeline.
     *
     * See the `ImageBlockEditing` for the similar integration that works in the opposite direction.
     *
     * @private
     */

  }, {
    key: "_setupClipboardIntegration",
    value: function _setupClipboardIntegration() {
      var editor = this.editor;
      var model = editor.model;
      var editingView = editor.editing.view;
      var imageUtils = editor.plugins.get('ImageUtils');
      this.listenTo(editor.plugins.get('ClipboardPipeline'), 'inputTransformation', function (evt, data) {
        var docFragmentChildren = Array.from(data.content.getChildren());
        var modelRange; // Make sure only <figure class="image"></figure> elements are dropped or pasted. Otherwise, if there some other HTML
        // mixed up, this should be handled as a regular paste.

        if (!docFragmentChildren.every(imageUtils.isBlockImageView)) {
          return;
        } // When drag and dropping, data.targetRanges specifies where to drop because
        // this is usually a different place than the current model selection (the user
        // uses a drop marker to specify the drop location).


        if (data.targetRanges) {
          modelRange = editor.editing.mapper.toModelRange(data.targetRanges[0]);
        } // Pasting, however, always occurs at the current model selection.
        else {
            modelRange = model.document.selection.getFirstRange();
          }

        var selection = model.createSelection(modelRange); // Convert block images into inline images only when pasting or dropping into non-empty blocks
        // and when the block is not an object (e.g. pasting to replace another widget).

        if (determineImageTypeForInsertionAtSelection(model.schema, selection) === 'imageInline') {
          var writer = new UpcastWriter(editingView.document); // Unwrap <figure class="image"><img .../></figure> -> <img ... />
          // but <figure class="image"><img .../><figcaption>...</figcaption></figure> -> stays the same

          var inlineViewImages = docFragmentChildren.map(function (blockViewImage) {
            // If there's just one child, it can be either <img /> or <a><img></a>.
            // If there are other children than <img>, this means that the block image
            // has a caption or some other features and this kind of image should be
            // pasted/dropped without modifications.
            if (blockViewImage.childCount === 1) {
              // Pass the attributes which are present only in the <figure> to the <img>
              // (e.g. the style="width:10%" attribute applied by the ImageResize plugin).
              Array.from(blockViewImage.getAttributes()).forEach(function (attribute) {
                return writer.setAttribute.apply(writer, _toConsumableArray(attribute).concat([imageUtils.getViewImageFromWidget(blockViewImage)]));
              });
              return blockViewImage.getChild(0);
            } else {
              return blockViewImage;
            }
          });
          data.content = writer.createDocumentFragment(inlineViewImages);
        }
      });
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [ImageEditing, ImageUtils, ClipboardPipeline];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'ImageInlineEditing';
    }
  }]);

  return ImageInlineEditing;
}(Plugin);

export { ImageInlineEditing as default };